<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="has_checkout">Modo de check-in</label>
                  <select
                    id="has_checkout"
                    v-model="setting.has_checkout"
                    name="has_checkout"
                    class="form-control"
                    @change="changeCheckin()"
                  >
                    <option value="0">Múltiplo — sem restrição</option>
                    <option value="1">Único — uma entrada por participante</option>
                    <option value="2">Único por local — uma entrada por tag</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="require_tag_on_scan">Exigir seleção de local antes de escanear?</label>
                  <select
                    id="require_tag_on_scan"
                    v-model="setting.require_tag_on_scan"
                    name="require_tag_on_scan"
                    class="form-control"
                    @change="changeCheckin()"
                  >
                    <option :value="true">SIM — bloqueia leitura sem local selecionado</option>
                    <option :value="false">NÃO — permite leitura sem local</option>
                  </select>
                </div>
              </div>
            </div>

            <hr class="my-3"/>
            <h6 class="text-muted text-uppercase font-size-12 mb-3">Dashboard de check-in</h6>
            <div class="row">
              <div class="col-sm-6" v-if="String(setting.has_checkout) !== '0'">
                <div class="form-group">
                  <label for="show_checkout_in_dashboard">Exibir saídas no dashboard?</label>
                  <select
                    id="show_checkout_in_dashboard"
                    v-model="setting.show_checkout_in_dashboard"
                    class="form-control"
                    @change="changeCheckin()"
                  >
                    <option :value="true">SIM — mostra entradas e saídas separadas</option>
                    <option :value="false">NÃO — oculta saídas das métricas</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="event_type">Tipo do evento</label>
                  <select
                    id="event_type"
                    v-model="setting.event_type"
                    class="form-control"
                    @change="changeCheckin()"
                  >
                    <option value="standard">Padrão (conferência, congresso, palestra)</option>
                    <option value="fair">Feira ou exposição (estandes)</option>
                  </select>
                  <small class="text-muted d-block mt-1" v-if="setting.event_type === 'fair'">
                    Em modo feira, "pessoas dentro agora" é estimado por janela de tempo.
                  </small>
                </div>
              </div>
              <div class="col-sm-6" v-if="setting.event_type === 'fair'">
                <div class="form-group">
                  <label for="dwell_window_minutes">
                    Janela de presença estimada (minutos)
                  </label>
                  <select
                    id="dwell_window_minutes"
                    v-model.number="setting.dwell_window_minutes"
                    class="form-control"
                    @change="changeCheckin()"
                  >
                    <option :value="5">5 min — fluxo muito rápido</option>
                    <option :value="10">10 min</option>
                    <option :value="15">15 min — recomendado (padrão de feira)</option>
                    <option :value="20">20 min</option>
                    <option :value="30">30 min — estandes interativos longos</option>
                    <option :value="45">45 min</option>
                    <option :value="60">60 min — palestras/workshops em estande</option>
                  </select>
                  <small class="text-muted d-block mt-1">
                    Quem fez check-in nesse local nos últimos {{ setting.dwell_window_minutes || 15 }} min é considerado "presente".
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- COLETA DE LEAD -->
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px;">
              <div>
                <h6 class="text-muted text-uppercase font-size-12 mb-1">Coleta de Lead</h6>
                <p class="mb-0 text-muted" style="font-size: 13px;">
                  Monte um formulário que os operadores preenchem no check-in, ao abrir os detalhes de um participante.
                  Pode ser preenchido várias vezes por participante.
                </p>
              </div>
              <button
                v-if="user.role === 'Admin'"
                type="button"
                class="btn btn-primary btn-rounded"
                @click="openLeadFormBuilder"
              >
                <i class="mdi mdi-form-select mr-1"></i> Configurar Formulário de Coleta de Lead
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block ">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Digite e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right" v-if="user.role === 'Admin'">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newTag()">
                      <i class="mdi mdi-plus mr-1"></i> Nova Tag
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="90%">Tag</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in tags" :key="list.id">
                    <td class="link" @click="editTag(list.id)">
                      <span class="badge font-size-14 badge-soft-primary" style="min-width:100px">{{ list.name }}</span>
                    </td>
                    <td><button v-if="user.role === 'Admin'" type="button" @click="deleteTag(list)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" :idTag="idTag" ref="formTag" @created="updateList"></modal-form>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import ModalForm from './Form'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import service from './services'

export default {
  components: {
    Layout,
    PageHeader,
    ModalForm
  },
  name: 'Controle de acesso',
  page: {
    title: 'Controle de acesso',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      timeout: null,
      modalForm: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      idTag: null,
      setting: {},
      perPage: 20,
      statusLabel: ['Inativo', 'Ativo'],
      submitted: false,
      title: 'Controle de acesso',
      items: [{
        text: 'Controle de acesso'
      },
      {
        text: 'Listagem',
        active: true
      }
      ]
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false

    this.GetSetting().then(() => {
      this.setting = this.data
    })
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settingEvent', { data: 'setting' }),
    ...mapState('tag', ['tags', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('settingEvent', {
      GetSetting: 'GetSetting'
    }),
    ...mapActions('tag', {
      getAll: 'getAll',
      delete: 'deleteTag'
    }),
    changeCheckin () {
      service.toogleSetting({
        has_checkout: this.setting.has_checkout,
        require_tag_on_scan: this.setting.require_tag_on_scan,
        show_checkout_in_dashboard: this.setting.show_checkout_in_dashboard,
        event_type: this.setting.event_type,
        dwell_window_minutes: this.setting.dwell_window_minutes
      }).then((data) => {
        successMessage('Sucesso: ' + data.data.message, 2500)
      }).catch((error) => {
        errorMessage('Atenção: ' + error.message)
      })
    },
    openLeadFormBuilder () {
      const loader = this.$loading.show()
      service.getLeadForm().then((res) => {
        loader.hide()
        const id = res.data && res.data.id
        if (id) {
          this.$router.push(`/settings/checkin/lead-form/${id}`)
        } else {
          errorMessage('Não foi possível abrir o formulário de coleta de lead.')
        }
      }).catch((error) => {
        loader.hide()
        errorMessage('Atenção: ' + (error.message || 'erro ao carregar o formulário de lead'))
      })
    },
    newTag () {
      this.$refs.formTag.open('')
      this.modalForm = true
    },
    editTag (id) {
      if (this.user.role === 'Admin') {
        this.$refs.formTag.open(id)
        this.modalForm = true
        this.idTag = id
      }
    },
    deleteTag (tag) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluido a tag: <b>${tag.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.delete(tag.id)
            successMessage('Sucesso: TAG excluída com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
